import * as React from "react";
import { ErrorMessage, useField } from "formik";

import TextError from "../../Errors/TextError";

import {
  FieldContainer,
  OptionContainer,
  StyledFormControl,
  StyledInput,
  StyledLabel,
  StyledOptionLabel,
  StyledRadio
} from "./style";


const RadioGroup = ({
  label,
  gridArea,
  options,
  ...rest
}) => {
  const [field] = useField(rest);

  return (
    <StyledFormControl
      gridArea={ gridArea }
    >
      <StyledLabel htmlFor={ field.name }>{ label }</StyledLabel>
      <FieldContainer
        id={ field.name }
        name={ field.name }
      >
        { options.map(option => {
          return (
            <OptionContainer
              key={ option.key }
            >
              <StyledOptionLabel htmlFor={ option.value }>
                <StyledInput
                  type="radio"
                  id={ option.value }
                  { ...field }
                  { ...rest }
                  name={ field.name }
                  value={ option.value }
                  checked={ field.value === option.value }
                />
                <StyledRadio></StyledRadio>
                { option.key }
              </StyledOptionLabel>
            </OptionContainer>
          )
        })}
      </FieldContainer>
      <ErrorMessage component={ TextError } name={ field.name } />
    </StyledFormControl>
  )
}


export default RadioGroup;
